import React from "react";
import { Switch } from "react-router-dom";
import styled from "styled-components";

function Login(props) {
  return (
    <Container>
      <Content>
          <CTA>
          <CTALogoOne src = "/images/cta-logo-one.svg" alt ="">
          </CTALogoOne>
          <Description>
          Get Premier Access to Raya and the Last Dragon for an additional fee
            with a Disney+ subscription. As of 03/26/21, the price of Disney+
            and The Disney Bundle will increase by $1.
          </Description>
          <SignUp>GET ALL THERE</SignUp>
          <CTALogoTwo src = "/images/cta-logo-two.png" alt ="">
          </CTALogoTwo >
          </CTA>
          
         <BgImage />
      </Content>
    </Container>
  );
}

const Container = styled.section`
  overflow: hidden;
  display: flex;
  flex-direction: column;
  text-align: center;
  height: 100vh;  
`;
const Content = styled.div`
  margin-bottom: 10vw;
  width: 100%;
  position: relative;
  min-height: 100vh;
  box-sizing: border-box; 
  justify-content: center;
  align-items: center;
  display: flex;
  flex-direction: column;
  padding: 80px 40px;
  height: 100%;
`;

const BgImage = styled.div `
background-size: cover;
height: 100%;
background-repeat: no-repeat;
background-image:url("/images/login-background.jpg");
background-position: top;
top: 0;
right: 0;
left: 0;
position: absolute;
z-index: -1;
`;

const CTA = styled.div `
display: flex;
flex-direction: column;
max-width: 650px;
width:100%;
`
const CTALogoOne = styled.img`
margin-top: 12px;
max-width: 600px;
min-height: 1px;
display: block;
width: 100%;
`;

const CTALogoTwo = styled.img `
max-width: 600px;
margin-bottom: 20px;
display: inline-block;
vertical-align: bottom;
width: 100%;
`

const Description = styled.p`
color: hsla(0,0%,95.3%,1);
font-size: 11px;
margin:0px 0px 24px;
line-height: 1.5;
letter-spacing: 1.5px;
`
const SignUp = styled.a `
font-weight: bold;
color: #f9f9f9;
background-color: #0063e5;
margin-bottom: 12px;
width: 100%;
letter-spacing: 1.5px;
font-size: 18px;
padding: 16.5px 0;
border-radius: 4px;

&:hover {
    background-color: #0483ee;
  }

`;




export default Login;
